export default __webpack_public_path__ + "ec09da7214e9dc1e86ca161053cc6ad7.ttf";